import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Plus, Edit, Trash2 } from 'lucide-react';
import { getAccessRules, getPlans } from '../../data/mockData';
import RuleFormModal from './RuleFormModal';
import ConfirmationDialog from '../shared/ConfirmationDialog';
import useDidFetch from '../../custom_hooks/useDidfetch';
import api from '../../services/ApiService';
import { ENDPOINTS } from '../../constant/ApiEndpoints';

const LogStatusBadge = ({ status }) => {
    const baseClasses = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';
    const statusClasses = {
        Granted: 'bg-green-100 text-green-800',
        Blocked: 'bg-red-100 text-red-800',
        active: 'bg-green-100 text-green-800',
        inactive: 'bg-red-100 text-red-800',
    };
    return <span className={`${baseClasses} ${statusClasses[status]} capitalize`}>{status}</span>;
};
const AccessRulesTab = () => {
    const [rules, setRules] = useState([]);
    const [plans] = useState(getPlans());
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingRule, setEditingRule] = useState(null);
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [deletingRule, setDeletingRule] = useState(null);
    const [btnLoading, setbtnLoading] = useState(false);

    const runOnce = useDidFetch();
    useEffect(() => {
        runOnce(() => {
            getDeviceList()
        });
    }, []);

    const getDeviceList = async () => {
        try {
            let response = await api.get(ENDPOINTS.getDevice);
            let result = response?.data;
            console.log(response);

            if (response?.status == 200 || response?.status == 201) {
                setRules(result?.devices ?? []);
            }
        } catch (error) {
            console.log("getDeviceList Error", error);
        }
    }

    const handleAdd = () => {
        setEditingRule(null);
        setIsModalOpen(true);
    };

    const handleEdit = (rule) => {
        setEditingRule(rule);
        setIsModalOpen(true);
    };

    const handleDelete = (rule) => {
        setDeletingRule(rule);
        setIsConfirmOpen(true);
    };

    const confirmDelete = () => {
        setRules(rules.filter(r => r.id !== deletingRule.id));
        toast.success(`Rule "${deletingRule.name}" has been deleted.`);
        setIsConfirmOpen(false);
        setDeletingRule(null);
    };

    const handleSave = async (deviceData) => {
        const isEdit = deviceData?.id != null; 
        console.log("handlesave fn data", deviceData);
        try {
            setbtnLoading(true);
            let response = isEdit ? await api.put(`${ENDPOINTS.updateDevice}/${deviceData?.id}`, deviceData) : await api.post(ENDPOINTS.createDevice, deviceData);
            let result = response?.data;
            if (response?.status == 200 || response?.status == 201) {
                toast.success(`Device has ${result?.message}`);
                setIsModalOpen(false);
                getDeviceList();
            }
        } catch (error) {
            console.log("save device error", error);
        } finally{ 
            setbtnLoading(false);
        }
    };

    return (
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold text-gray-800">Defined Device Configuration</h3>
                <button onClick={handleAdd} className="flex items-center gap-2 px-4 py-2 bg-brand-red text-white rounded-lg hover:bg-red-600 text-sm font-medium">
                    <Plus size={18} /> Add Device
                </button>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full text-sm text-left text-gray-500">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th scope="col" className="px-6 py-3">Serial Number</th>
                            <th scope="col" className="px-6 py-3">Endpoint</th>
                            <th scope="col" className="px-6 py-3">Status</th>
                            <th scope="col" className="px-6 py-3">created At</th>
                            <th scope="col" className="px-6 py-3 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rules.map(rule => (
                            <tr key={rule.id} className="bg-white border-b hover:bg-gray-50">
                                <td className="px-6 py-4 font-medium text-gray-900">{rule?.serial_no ?? '--'}</td>
                                <td className="px-6 py-4">{rule?.endpoint ?? '--'}</td>
                                <td className="px-6 py-4">
                                    <LogStatusBadge status={rule?.status} /> 
                                </td>
                                <td className="px-6 py-4">{rule?.created_at ?? '--'}</td>
                                <td className="px-6 py-4 text-right">
                                    <div className="flex items-center justify-end gap-1">
                                        <button onClick={() => handleEdit(rule)} title="Edit Rule" className="p-2 text-gray-500 hover:bg-gray-200 rounded-full transition-colors"><Edit size={18} /></button>
                                        {/* <button onClick={() => handleDelete(rule)} title="Delete Rule" className="p-2 text-red-500 hover:bg-red-100 rounded-full transition-colors"><Trash2 size={18} /></button> */}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <RuleFormModal isLoading={btnLoading} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={handleSave} rule={editingRule} plans={plans} />
            <ConfirmationDialog isOpen={isConfirmOpen} onClose={() => setIsConfirmOpen(false)} onConfirm={confirmDelete} title="Confirm Deletion" description={`Are you sure you want to delete the rule "${deletingRule?.name}"?`} />
        </div>
    );
};

export default AccessRulesTab;
